export const defaultError = 'Try again later or contact support.'

export const workflowErrors = {
  create: {
    404: (entity) =>
      `This ${entity} no longer exists or you no longer have access to it. Try refreshing page.`,
    502: () =>
      'The workflow feature is temporarily down. Content support or try again later.',
  },
  update: {
    502: () =>
      'The workflow feature is temporarily down. Content support or try again later.',
  },
  read: {
    502: () =>
      'The workflow feature is temporarily down. Content support or try again later.',
  },
}

export const stageErrors = {
  update: {
    404: (entity) =>
      `This phase no longer exists or you no longer have access to the ${entity}. Try refreshing page.`,
    422: (entity) =>
      `Workflow phase could not be updated or the ${entity} permissions have changed.`,
    502: () =>
      'The workflow feature is temporarily down. Content support or try again later.',
  },
  delete: {
    404: (entity) =>
      `This phase no longer exists or you no longer have access to the ${entity}. Try refreshing page.`,
    502: () =>
      'The workflow feature is temporarily down. Content support or try again later.',
  },
}

export const newStageErrors = {
  create: {
    404: () =>
      'This workflow no longer exists or you no longer have access to it. Try refreshing page.',
    422: () =>
      'Unable to create workflow phase. Try again later or contact support.',
    502: () =>
      'The workflow feature is temporarily down. Content support or try again later.',
  },
}

export const assignmentErrors = {
  create: {
    404: () =>
      'This phase no longer exists or you no longer have access to it. Try refreshing page.',
    422: () =>
      'Unable to create assignment. Try again later or contact support.',
    502: () =>
      'The workflow feature is temporarily down. Content support or try again later.',
  },
  update: {
    404: () =>
      'This assignment no longer exists or you no longer have access to it. Try refreshing page.',
    422: (entity) =>
      `Workflow assignment was deleted or you or the user you tried to assign no longer has access to the ${entity}.`,
    502: () =>
      'The workflow feature is temporarily down. Content support or try again later.',
  },
  delete: {
    404: () =>
      'This assignment no longer exists or you no longer have access to it. Try refreshing page.',
    502: () =>
      'The workflow feature is temporarily down. Content support or try again later.',
  },
}

export const responseErrors = {
  create: {
    404: () =>
      'This assignment no longer exists or you no longer have access to it. Try refreshing page.',
    422: () => 'Unable to create response. Try again later or contact support.',
    502: () =>
      'The workflow feature is temporarily down. Content support or try again later.',
  },
}
